import KpiCard from './KpiCard'
import type { MeetingStats } from '../../types'

export default function MeetingKpiCard({ stats, teamId }: { stats: MeetingStats; teamId: number }) {
  const ratio = stats.total_weeks_in_quarter > 0
    ? stats.completed_this_quarter / stats.total_weeks_in_quarter
    : 0
  const color = ratio >= 0.8 ? 'green' : ratio >= 0.5 ? 'amber' : 'red'
  const streakText = stats.streak_count > 0 ? `${stats.streak_count}-week streak` : 'No active streak'

  return (
    <KpiCard
      label="Meeting Cadence"
      value={`${stats.completed_this_quarter}/${stats.total_weeks_in_quarter} weeks`}
      subtitle={streakText}
      href={`/teams/${teamId}/agendas`}
      statusColor={stats.has_any_meetings ? color : 'neutral'}
      icon={
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
          <line x1="16" y1="2" x2="16" y2="6" />
          <line x1="8" y1="2" x2="8" y2="6" />
          <line x1="3" y1="10" x2="21" y2="10" />
        </svg>
      }
    />
  )
}
